import {
  FETCH_CUSTOMERS_STARTED,
  FETCH_CUSTOMERS_SUCCESS,
  CANCEL_SUBSCRIPTION_STARTED,
  CANCEL_SUBSCRIPTION_SUCCESS,
  FETCH_INVOICES_STARTED,
  FETCH_INVOICES_SUCCESS,
  CUSTOMERS_FETCHED_STATUS,
  INVOICES_FETCHED_STATUS
} from "../actionTypeConstants/constants";

const initialState = {
  isCancellingSubscription: false,
  isCustomersFetching: false,
  isCustomersFetched: false,
  customers_offset: 0,
  customers_limit: 15,
  customers: [],
  isInvoicesFetching: false,
  isInvoicesFetched: false,
  starting_after: "",
  invoices_limit: 15,
  invoices: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMERS_STARTED:
      return { ...state, isCustomersFetching: action.payload.status };
    case FETCH_CUSTOMERS_SUCCESS: {
      let { customers } = state;
      

      customers = [...action.payload.data, ...customers];
      let updatedCustomers = [...new Map(customers.map(customer =>
        [customer["id"], customer])).values()]
      return {
        ...state,
        isCustomersFetching: action.payload.status,
        customers: updatedCustomers,
        customers_offset: action.payload.offset,
      };
    }
    case CUSTOMERS_FETCHED_STATUS:
      return { ...state, isCustomersFetched: action.payload.status };
    case CANCEL_SUBSCRIPTION_STARTED:
      return { ...state, isCancellingSubscription: action.payload.status };
    case CANCEL_SUBSCRIPTION_SUCCESS: {
      let { customers } = state;
      const { id } = action.payload.data;
      customers = [...customers];

      let objIndex = customers.findIndex((obj) => obj.id === id);
      customers[objIndex] = action.payload.data;

      return {
        ...state,
        customers,
        isCancellingSubscription: action.payload.status,
      };
    }

    case FETCH_INVOICES_STARTED:
      return { ...state, isInvoicesFetching: action.payload.status };
    case FETCH_INVOICES_SUCCESS: {
      let { invoices } = state;
      invoices = [...invoices, ...action.payload.data];
      let updatedInvoices = [...new Map(invoices.map(invoice =>
        [invoice["id"], invoice])).values()]
      return {
        ...state,
        isInvoicesFetching: action.payload.status,
        invoices: updatedInvoices,
        starting_after: action.payload.offset,
      };
    }
    case INVOICES_FETCHED_STATUS:
      return { ...state, isInvoicesFetched: action.payload.status };

    default:
      return state;
  }
};
